import getSnippetInstance from '../zend-desk/get-snippet-instance';

const showSearchForm = async () => {
  const widget = await getSnippetInstance();
  widget.showSearchForm();
};

export default showSearchForm;
